import { pouzivatelIsAdmin } from './permissions';
import routes from '../routing/routes';
import CurrentUserDetail from '../model/currentuser/CurrentUserDetail';
import Uuid from '../model/Uuid';

const getSprievodnyDokumentRoute = (
  pouzivatel: CurrentUserDetail,
  opravnenieSprievodneDokumenty: boolean,
  currentStadiumEqualsLatest: boolean,
  latestStadium: boolean,
  stadiumHistoriaUuid: Uuid,
  type: string,
  year: number,
  index: number,
): string => {
  if (pouzivatelIsAdmin(pouzivatel)) {
    return routes.procesy.detail.sprievodneDokumenty.editAsAdmin.withParams(type, year, index, stadiumHistoriaUuid);
  }
  if (opravnenieSprievodneDokumenty && latestStadium && currentStadiumEqualsLatest) {
    return routes.procesy.detail.sprievodneDokumenty.edit.withParams(type, year, index);
  }
  return routes.procesy.detail.sprievodneDokumenty.list.withParams(type, year, index, stadiumHistoriaUuid);
};

export default getSprievodnyDokumentRoute;
